import React, { useRef, useState } from 'react';
import { NavLink } from "react-router-dom";
import NavbarTag from "react-bootstrap/Navbar";
import "../Style/contact.css"
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    emailjs
      .sendForm('bara_company', 'template_s9yq6hr', form.current, {
        publicKey: '89-ucNWXINBXNlnCT',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          setSubmitStatus('success');
          setIsSubmitting(false);
          form.current.reset();
          setIsButtonDisabled(true);
        },
        (error) => {
          console.log('FAILED...', error.text);
          setSubmitStatus('error');
          setIsSubmitting(false);
        },
      );
  };

  const handleInputChange = () => {
    // Check if all required fields have content
    const formData = new FormData(form.current);
    const name = formData.get('from_name')?.trim();
    const email = formData.get('from_email')?.trim();
    const message = formData.get('message')?.trim();
    
    if (name && email && message) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  };

  return (
    <>
      <div className="main-section contact-page">
        <section>
          <NavbarTag expand="lg">
            <NavLink
              exact
              to="/"
              className="listItem"
              activeclassname="activeItem"
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className="listItem"
              activeclassname="activeItem"
            >
              About
            </NavLink>
            <NavLink
              to="/contact"
              className="listItem"
              activeclassname="activeItem"
            >
              Contact
            </NavLink>
            <NavLink
              to="/products"
              className="listItem"
              activeclassname="activeItem"
            >
              Products
            </NavLink>
            <NavLink
              to="/services"
              className="listItem"
              activeclassname="activeItem"
            >
              Services
            </NavLink>
          </NavbarTag>
        </section>

        <div className="contact-form-shell">
        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <label htmlFor="fname">Full Name</label>
          <input 
            type="text" 
            id="fname" 
            name="from_name" 
            placeholder="Your full name..." 
            onChange={handleInputChange}
            required
          />

          <label htmlFor="email">Email Address</label>
          <input 
            type="email" 
            id="email" 
            name="from_email" 
            placeholder="Your email address..." 
            onChange={handleInputChange}
            required
          />

          <label htmlFor="subject">Content</label>
          <textarea 
            id="subject" 
            name="message" 
            placeholder="Write something..." 
            onChange={handleInputChange}
            required
          ></textarea>

          {submitStatus === 'success' && (
            <p className="contact-form-status contact-form-status--success" role="status">
              Message sent successfully! We&apos;ll get back to you soon.
            </p>
          )}

          {submitStatus === 'error' && (
            <p className="contact-form-status contact-form-status--error" role="alert">
              Failed to send message. Please try again later.
            </p>
          )}

          <input 
            type="submit" 
            value={isSubmitting ? "Sending..." : "Submit"} 
            disabled={isButtonDisabled || isSubmitting}
            className={isButtonDisabled || isSubmitting ? 'disabled' : ''}
          />
        </form>
        </div>
      </div>
    </>
  );
}

export default Contact
